/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import defaultImage from "assets/images/team-2.jpg"; // fallback image

export default function studentsTableData(students = [], handleReject) {
  const Student = ({ image, name }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image || defaultImage} name={name} size="sm" />
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  const Action = ({ id }) => (
    <MDBox display="flex" alignItems="center" gap={1}>
      <MDBadge
        badgeContent="Remove"
        color="error"
        variant="gradient"
        size="sm"
        sx={{ cursor: "pointer" }}
        onClick={() => handleReject(id)}
      />
    </MDBox>
  );

  return {
    columns: [
      { Header: "id", accessor: "id", width: "20%", align: "left" },
      { Header: "action", accessor: "action", align: "center" },
    ],

    rows: students.map((student) => ({
      id: <Student image={""} name={student} />,
      action: <Action id={student} />,
    })),
  };
}
